if (!window.PkCommercialTimer) {
  class PkCommercialTimer extends HTMLElement {
    constructor() {
      super();
      this.interval = null;
    }


    connectedCallback() {
      const dayName = this.dataset.day?.toLowerCase();
      const hour = parseInt(this.dataset.hour || "0", 10);
      const minute = parseInt(this.dataset.minute || "0", 10);
      const endHour = parseInt(this.dataset.endHour || "23", 10);
      const endMinute = parseInt(this.dataset.endMinute || "59", 10);

      if (!dayName || isNaN(hour) || isNaN(minute)) return;

      const now = new Date();
      const isNowHappy = this.isNowInActivePeriod(dayName, hour, minute);

      let targetDate;

      if (isNowHappy) {
        targetDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          endHour,
          endMinute,
          0,
          0
        );
        this.showProductList();
      } else {
        targetDate = this.getNextOccurrence(dayName, hour, minute);
        this.hideProductList();
      }

      this.startCountdown(targetDate);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    getNextOccurrence(dayName, startHour, startMinute) {
      const daysMap = {
        sunday: 0,
        monday: 1,
        tuesday: 2,
        wednesday: 3,
        thursday: 4,
        friday: 5,
        saturday: 6,
      };

      const now = new Date();
      const targetDay = daysMap[dayName];
      const targetMonth = parseInt(this.dataset.month, 10); // 1 = janvier
      const targetYear = parseInt(this.dataset.year || now.getFullYear(), 10);

      if (
        typeof targetDay === "undefined" ||
        isNaN(targetMonth) ||
        isNaN(targetYear)
      ) {
        return null;
      }

      const occurrences = [];
      let date = new Date(targetYear, targetMonth - 1, 1, startHour, startMinute);

      while (date.getMonth() === targetMonth - 1) {
        if (date.getDay() === targetDay && date > now) {
          occurrences.push(new Date(date));
        }
        date.setDate(date.getDate() + 1);
      }

      return occurrences.length > 0 ? occurrences[0] : null;
    }

    isNowInActivePeriod(dayName, hour, minute) {
      const daysMap = {
        sunday: 0,
        monday: 1,
        tuesday: 2,
        wednesday: 3,
        thursday: 4,
        friday: 5,
        saturday: 6,
      };

      const now = new Date();
      const targetDay = daysMap[dayName];
      if (typeof targetDay === "undefined") return false;

      if (now.getDay() !== targetDay) return false;

      const nowMinutes = now.getHours() * 60 + now.getMinutes();
      const startMinutes = hour * 60 + minute;
      const endHour = parseInt(this.dataset.endHour || "23", 10);
      const endMinute = parseInt(this.dataset.endMinute || "59", 10);
      const endMinutes = endHour * 60 + endMinute;

      return nowMinutes >= startMinutes && nowMinutes < endMinutes;
    }

    startCountdown(targetDate) {
      if (!targetDate) return;

      const dayEl = this.querySelector(".days .countdown-timer--column--number");
      const hourEl = this.querySelector(".hours .countdown-timer--column--number");
      const minEl = this.querySelector(".minutes .countdown-timer--column--number");
      const secEl = this.querySelector(".seconds .countdown-timer--column--number");

      const update = () => {
        const now = new Date();
        const diff = targetDate - now;

        if (diff <= 0) {
          clearInterval(this.interval);

          const dayName = this.dataset.day?.toLowerCase();
          const hour = parseInt(this.dataset.hour || "0", 10);
          const minute = parseInt(this.dataset.minute || "0", 10);
          const isNowHappy = this.isNowInActivePeriod(dayName, hour, minute);

          let newTarget;

          if (isNowHappy) {
            // On entre en Happy Hour → viser la fin
            const endHour = parseInt(this.dataset.endHour || "23", 10);
            const endMinute = parseInt(this.dataset.endMinute || "59", 10);
            newTarget = new Date(
              now.getFullYear(),
              now.getMonth(),
              now.getDate(),
              endHour,
              endMinute
            );
            this.showProductList();
            location.reload();
          } else {
            // Happy Hour fini → viser la prochaine
            newTarget = this.getNextOccurrence(dayName, hour, minute);
            this.hideProductList();
            location.reload();
          }

          this.startCountdown(newTarget);
          return;
        }

        const seconds = Math.floor((diff / 1000) % 60);
        const minutes = Math.floor((diff / 1000 / 60) % 60);
        const hours = Math.floor((diff / 1000 / 60 / 60) % 24);
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));

        dayEl.textContent = days;
        hourEl.textContent = hours;
        minEl.textContent = minutes;
        secEl.textContent = seconds;
      };

      update();
      this.interval = setInterval(update, 1000);
    }

    showProductList() {
      const el = document.querySelector('[data-dynamic-visibility]');
      if (el) el.style.display = '';
    }

    hideProductList() {
      const el = document.querySelector('[data-dynamic-visibility]');
      if (el) el.style.display = 'none';
    }

    // Optionnel : forcer un rerender si besoin
    forceRerenderProductList() {
      const el = document.querySelector('[data-dynamic-visibility]');
      if (!el) return;
      const clone = el.cloneNode(true);
      el.replaceWith(clone);
    }
  }
  window.PkCommercialTimer = PkCommercialTimer;
}

customElements.get('pk-commercial-timer') || customElements.define('pk-commercial-timer', PkCommercialTimer);

